import { useEffect, useState } from "react";
import { BusinessRecord, getAllBusinesses } from "../businesses";
import { getApiErrorMessage } from "../../lib";

type UseBusinessesState = {
  businesses: BusinessRecord[];
  isLoading: boolean;
  error: string | null;
};

export const useBusinesses = () => {
  const [state, setState] = useState<UseBusinessesState>({
    businesses: [],
    isLoading: true,
    error: null,
  });
  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      setState((prev) => ({ ...prev, isLoading: true, error: null }));
      try {
        const businesses = await getAllBusinesses();
        if (!isMounted) return;
        setState({ businesses, isLoading: false, error: null });
      } catch (error) {
        if (!isMounted) return;
        const message = getApiErrorMessage(error, "Unable to load businesses");
        setState({ businesses: [], isLoading: false, error: message });
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [refreshCount]);

  return {
    ...state,
    refetch: () => setRefreshCount((prev) => prev + 1),
  };
};
